if (!customElements.get('promo-countdown-inline')) {
  customElements.define(
    'promo-countdown-inline',
    class PromoCountdownInline extends HTMLElement {
      connectedCallback() {
        this.endTime = this.parseEndTime();
        if (this.endTime === null) return;

        this.templates = {
          oneHour: this.dataset.labelOneHour || 'Ends in 1 hour',
          nHours: this.dataset.labelNHours || 'Ends in {count} hours',
          oneMinute: this.dataset.labelOneMinute || 'Ends in 1 min',
          nMinutes: this.dataset.labelNMinutes || 'Ends in {count} min',
        };

        this.render();

        this.intervalId = setInterval(() => this.render(), 60 * 1000);
      }

      disconnectedCallback() {
        if (this.intervalId) clearInterval(this.intervalId);
      }

      parseEndTime() {
        const raw = this.dataset.endDate;
        if (!raw) return null;
        const seconds = parseInt(raw, 10);
        if (isNaN(seconds)) return null;
        return seconds * 1000;
      }

      render() {
        const remaining = this.endTime - Date.now();
        if (remaining <= 0) {
          this.style.display = 'none';
          if (this.intervalId) clearInterval(this.intervalId);
          return;
        }

        const hours = Math.floor(remaining / (60 * 60 * 1000));
        const minutes = Math.floor((remaining % (60 * 60 * 1000)) / (60 * 1000));

        let phrase;
        if (hours >= 1) {
          phrase = hours === 1
            ? this.templates.oneHour
            : this.templates.nHours.replace('%count%', hours);
        } else {
          const m = Math.max(1, minutes);
          phrase = m === 1
            ? this.templates.oneMinute
            : this.templates.nMinutes.replace('%count%', m);
        }

        if (this.textContent !== phrase) {
          this.textContent = phrase;
        }
      }
    },
  );
}
